export const getImageType = (imagePath) => {
  if (!imagePath) return 'image/jpeg'

  return typeof imagePath === 'string' && imagePath.toLowerCase().indexOf('.webp') === imagePath.length - 5
    ? 'image/webp'
    : 'image/jpeg'
}

export const imageBreakpoints = [
  { media: '(min-width: 1440px)', key: 'desktop' },
  { media: '(min-width: 768px)', key: 'tablet' },
  { media: '(min-width: 0px)', key: 'mobile' },
]
